import RootState from '../../rootState';
import MasterData from '../../../models/masterData';

export class Action {
    type: string;
    specialties: Array<MasterData>;
}

export interface State {
    loading: boolean;
    specialties: Array<MasterData>;
}

export const types = {
    ACTION_SERVER_DATA_REQUESTED: 'ACTION_SERVER_DATA_REQUESTED',
    ACTION_SERVER_DATA_FAILED: 'ACTION_SERVER_DATA_FAILED',

    GET_ALL_SPECIALTIES_ASYNC: 'GET_ALL_SPECIALTIES_ASYNC',
    GET_ALL_SPECIALTIES_SUCCEEDED: 'GET_ALL_SPECIALTIES_SUCCEEDED',
};

const baseAction = new Action();

export const actions = {
    actionServerDataRequested: (): Action => ({
        ...baseAction,
        type: types.ACTION_SERVER_DATA_REQUESTED
    }),

    actionServerDataFailed: (): Action => ({
        ...baseAction,
        type: types.ACTION_SERVER_DATA_FAILED
    }),

    getAllSpecialtiesAsync: (): Action => ({
        ...baseAction,
        type: types.GET_ALL_SPECIALTIES_ASYNC
    }),

    getAllSpecialtiesSucceeded: (specialties: Array<MasterData>): Action => ({
        ...baseAction,
        type: types.GET_ALL_SPECIALTIES_SUCCEEDED,
        specialties
    }),
};

export const selectors = {
    getState: (rootState: RootState): State => rootState.entities.masterData,

    getLoading(rootState: RootState): boolean {
        const { loading } = this.getState(rootState);
        return loading;
    },

    getSpecialties(rootState: RootState): Array<MasterData> {
        const { specialties } = this.getState(rootState);
        return specialties;
    },
};


// WEBPACK FOOTER //
// ./src/modules/entities/masterData/index.ts